import React, { FC, Fragment, useEffect, useState } from "react";
import "./ScrollToTopButton.scss";
import arrowUpIcon from "../../assets/arrowUpDeposit.svg";
import { Y_SCROLL_POSITION_FOR_SCROLL_BUTTON } from "../../common/constants/common.constants";

const ScrollToTopButton: FC = () => {
  const [showButton, toggleButton] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", handleShowButton);
    return () => {
      window.removeEventListener("scroll", handleShowButton);
    };
  }, []);

  const handleShowButton = () => {
    toggleButton(window.scrollY > Y_SCROLL_POSITION_FOR_SCROLL_BUTTON);
  };

  const scrollToTop = () => {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
  };

  return (
    <Fragment>
      {showButton && (
        <button className="scroll-to-top" onClick={scrollToTop}>
          Back to top
          <img src={arrowUpIcon} />
        </button>
      )}
    </Fragment>
  );
};

export default ScrollToTopButton;
